import { connect } from 'react-redux'
import { setMenuSelectedState } from 'store/menu-selected/actions'
import Passes from './Passes'
import PassesActions, { setPassDetails } from '../../store/passes/actions'

const mapStateToProps = state => ({
  loading: state.passes.loading,
  workOrders: state.passes.passes,
  siteCode: state.user && state.user.assignments ? state.user.assignments[0].locationCode : null,
  assignments: state.user && state.user.assignments ? state.user.assignments : null,
  userChecked: state.user.checked
})

const mapDispatchToProps = dispatch => ({
  setMenuSelectedState: (state) => {
    dispatch(setMenuSelectedState(state))
  },
  loadPasses: (siteCode) => {
    dispatch({ type: PassesActions.fetchPasses, siteCode })
  },
  setPassDetails: (state, actionRequired) => {
    dispatch(setPassDetails(state, actionRequired))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Passes)



// WEBPACK FOOTER //
// ./src/components/Passes/index.jsx